import { render, staticRenderFns } from "./OrderSummaryDiscountBreakdown.vue?vue&type=template&id=6d08bb01&"
import script from "./OrderSummaryDiscountBreakdown.vue?vue&type=script&lang=ts&"
export * from "./OrderSummaryDiscountBreakdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports